
import * as THREE from "three";
const shader = ` 
  precision highp float;

  uniform vec2 u_resolution;
  uniform vec2 u_chunk;
  uniform float u_seed;
  
  float random(vec2 st) {
      return fract(sin(dot(st.xy, vec2(12.9898,78.233))) * u_seed);
  }
  
  float noise(vec2 st) {
      vec2 i = floor(st);
      vec2 f = fract(st);
  
      // Four corners in 2D of a tile
      float a = random(i);
      float b = random(i + vec2(1.0, 0.0));
      float c = random(i + vec2(0.0, 1.0));
      float d = random(i + vec2(1.0, 1.0));
  
      // Smooth Interpolation
  
      // Cubic Hermine Curve.  Same as SmoothStep()
      vec2 smooth_f = f*f*(3.0-2.0*f);
      // Mix 4 coorners' values together using smoothstep-like interpolation
      float x1 = mix(a, b, smooth_f.x);
      float x2 = mix(c, d, smooth_f.x);
  
      return mix(x1, x2, smooth_f.y);
  }
  
  float fbm(vec2 st) {
      float value = 0.0;
      float amplitude = 1.0;
      float totalAmplitude = 0.0;
      float frequency = 1.0;
      const int octaves = 5;
  
      for (int i = 0; i < octaves; i++) {
          value += amplitude * noise(st * frequency);
          totalAmplitude += amplitude;
          amplitude *= 0.5;
          frequency *= 2.0;
      }
  
      return value / totalAmplitude;
  }
  
  void main() {
      vec2 l = vec2(0,0);
      vec2 ch = u_chunk.xy;
      if(ch.xy != l.xy){
          ch.y *= -1.0;
      } 
      vec2 st = gl_FragCoord.xy / u_resolution.xy;
      st.x *= u_resolution.x/u_resolution.y; 
      st *= (0.1); // Scale the coordinates
  
      float n = fbm((st + ch)  / (u_resolution.x / 2.0));
  
      gl_FragColor = vec4(vec3(n), 1.0);
  }
`;
function rttobject(cam, sce) {
    this.camera = cam
    this.scene = sce
}

let rttplanemesh,rtTexture, scene,camera
const target = new THREE.Vector3();

export function setuprtt(tilesize) {
    const width = window.innerWidth,
        height = window.innerHeight;
    scene = new THREE.Scene();
    camera = new THREE.OrthographicCamera(
        tilesize / -2,
        tilesize / 2,
        tilesize / 2,
        tilesize / -2,
        -10000,
        10000
    );

    const rttplane = new THREE.PlaneGeometry(tilesize, 10, 1, 1);
    const rttplanetexture = new THREE.ShaderMaterial({
        //debug seed 7.052137685676513890
        fragmentShader: shader,
        uniforms: {
          u_seed: { value: 2442 },
          u_chunk: { value: null },
          u_resolution: { value: new THREE.Vector2(tilesize, tilesize) },
        },
      });
    rttplanemesh = new THREE.Mesh(rttplane, rttplanetexture);
      scene.add(rttplanemesh);
  

    return new rttobject(camera, scene)
}



export default function rtt(chunk, renderer) {

    let rendersize = 1000;
    //RTT
    //i dont really know why but if you put this in INIT it will set every chunk to one displacment rendered or not
    rtTexture = new THREE.WebGLRenderTarget(rendersize, rendersize);

    let position = chunk.getCenter(target);
    rttplanemesh.material.uniforms.u_chunk.value = new THREE.Vector2(
        Math.floor(position.x),
        Math.floor(position.z)
      );

    rttplanemesh.material.uniformsNeedUpdate = true;
    rttplanemesh.material.needsUpdate = true;

    renderer.setRenderTarget(rtTexture);
    renderer.clear()
    renderer.render(scene, camera);

    //End of rtt

    chunk.rttarget = rtTexture;
    return rtTexture.texture;

}
